<template>
  <div :class="$style.Container">
    选择团队人数
    <Select
      :class="$style.Select"
      :value="props.value"
      @change="(v) => updateValue(v)"
      :options="options"
      :dropdownStyle="{
        zIndex: 2000,
      }"
      :disabled="props.disabled"
      :dropdownMatchSelectWidth="101"
    />
    <div v-if="showTip" :class="$style.Tip"
      >购买后您的团队人员上限将在{{ props.expireTime }}更改至{{ props.value }}人</div
    >
  </div>
</template>

<script lang="ts" setup>
  import { Select } from 'ant-design-vue';

  const props = defineProps({
    value: {
      type: String,
      default: '',
    },

    expireTime: {
      type: String,
      default: '',
    },

    showTip: {
      type: String,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  });
  const emits = defineEmits(['update:value']);
  function updateValue(v) {
    console.log(v);
    emits('update:value', v);
  }

  const options = [
    {
      label: '1-5人',
      value: '5',
    },
    {
      label: '6-10人',
      value: '10',
    },
    {
      label: '11-20人',
      value: '20',
    },
    {
      label: '20人以上',
      value: '',
    },
  ];
</script>

<style lang="less" module>
  .Container {
    color: rgba(255, 255, 255, 0.85);
  }

  .Select {
    // min-width: 101px;
    border: unset !important;
    box-shadow: unset !important;
    outline: unset !important;
    border-left: 1px solid rgba(66, 66, 66, 1) !important;
    margin-left: 12px !important;
    background-color: unset !important;

    > div {
      border: unset !important;
      box-shadow: unset !important;
      outline: unset !important;
      background-color: unset !important;
      height: 24px !important;
      display: flex;
      align-items: center;
    }

    :global {
      .ant-select-selection-item {
        color: rgba(255, 255, 255, 0.85);
      }
    }
  }

  .Tip {
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
    color: rgba(255, 255, 255, 0.45);
    margin-top: 8px;
  }
</style>
